"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var server_1 = require("react-dom/server");
var react_1 = __importDefault(require("react"));
var x_axis_label_1 = __importDefault(require("./x-axis-label"));
var charts_styled_1 = require("./charts.styled");
var legend_item_formatter_1 = __importStar(require("./legend-item-formatter"));
var init_live_query_1 = __importDefault(require("./init-live-query"));
var runtime_formatters_1 = require("./runtime-formatters");
var responsive_util_1 = require("../responsive/responsive-util");
var mobile_legend_item_formatter_1 = __importDefault(require("./mobile-legend-item-formatter"));
exports.CancelLiveUpdate = 'cancel-live-update';
// eslint-disable-next-line max-lines-per-function
function createChartsConfig(options, translation) {
    var theme = options.theme, _a = options.labelFormat, labelFormat = _a === void 0 ? 'default' : _a, toolTipLabelFormat = options.toolTipLabelFormat, timezoneOffset = options.timezoneOffset, _b = options.live, live = _b === void 0 ? false : _b, liveQuery = options.liveQuery, formatWithDigits = options.locale.formatWithDigits, height = options.height, width = options.width, categories = options.categories, _c = options.allowDecimalsOnYAxis, allowDecimalsOnYAxis = _c === void 0 ? true : _c, tooltipSignificantDigits = options.tooltipSignificantDigits, valueFormatter = options.valueFormatter, startValueOnXAxis = options.startValueOnXAxis, is12HourSystem = options.is12HourSystem;
    var activeToolTipLabelFormat = toolTipLabelFormat || labelFormat;
    var charts = theme.colours.charts;
    var yAxisFormatter = runtime_formatters_1.digitsFormatter(formatWithDigits, 2);
    return {
        time: {
            timezoneOffset: timezoneOffset,
            useUTC: false,
        },
        chart: {
            backgroundColor: 'transparent',
            height: height ? height : null,
            width: width ? width : null,
            marginRight: 20,
            zoomType: 'x',
            events: {
                load: function () {
                    return __awaiter(this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!(live && liveQuery)) return [3 /*break*/, 2];
                                    return [4 /*yield*/, init_live_query_1.default.call(this, live, liveQuery)];
                                case 1:
                                    _a.sent();
                                    _a.label = 2;
                                case 2: return [2 /*return*/];
                            }
                        });
                    });
                },
            },
        },
        credits: {
            enabled: false,
        },
        colors: charts.colors,
        title: { text: '' },
        plotOptions: {
            column: {
                borderWidth: 0,
                maxPointWidth: 30,
            },
            series: {
                marker: {
                    enabled: false,
                    states: {
                        hover: {
                            lineWidth: 0,
                        },
                    },
                },
            },
        },
        xAxis: {
            type: categories ? 'category' : 'datetime',
            min: startValueOnXAxis,
            labels: categories
                ? {
                    formatter: undefined,
                    style: {
                        color: 'rgba(255, 255, 255, 0.9)',
                    },
                }
                : {
                    align: 'left',
                    style: { color: charts.label },
                    useHTML: true,
                    formatter: x_axis_label_1.default(labelFormat, translation, is12HourSystem),
                },
            lineWidth: 0,
            minorGridLineWidth: 0,
            minorTickLength: 0,
            tickLength: 0,
            categories: categories ? categories : undefined,
            crosshair: {
                width: 1,
                color: charts.label,
            },
        },
        yAxis: {
            allowDecimals: allowDecimalsOnYAxis,
            gridLineWidth: 1,
            gridLineColor: charts.border,
            title: { text: '' },
            labels: {
                style: { color: charts.label },
                useHTML: true,
                format: '{value:.' + tooltipSignificantDigits + 'f}',
                formatter: function () {
                    return server_1.renderToStaticMarkup(react_1.default.createElement(charts_styled_1.YAxisLabel, { theme: theme }, yAxisFormatter(this.value)));
                },
            },
        },
        legend: {
            align: 'left',
            itemStyle: { color: charts.label },
            itemHoverStyle: { color: charts.labelHover },
            itemMarginBottom: -15,
            itemMarginTop: 5,
            padding: 0,
            squareSymbol: false,
            symbolRadius: 1,
            symbolWidth: 0,
            symbolHeight: 0,
            useHTML: true,
            labelFormatter: legend_item_formatter_1.default(theme),
        },
        tooltip: {
            backgroundColor: charts.tooltipBackground,
            borderWidth: 0,
            shared: true,
            style: {
                color: charts.label,
            },
            useHTML: true,
            headerFormat: "<div style=\"text-transform: uppercase; margin-bottom: 4px; color: " + charts.tooltipHeader + "\">{point.key}</div>",
            xDateFormat: activeToolTipLabelFormat === 'minute'
                ? "" + (is12HourSystem ? '%l:%M %p' : '%H:%M')
                : activeToolTipLabelFormat === 'day-hour'
                    ? "%d %B %Y - " + (is12HourSystem ? '%l:%M %p' : '%H:%M')
                    : '%d %B %Y',
            pointFormatter: legend_item_formatter_1.pointFormatter({ theme: theme, locale: options.locale, valueFormatter: valueFormatter, tooltipSignificantDigits: tooltipSignificantDigits }),
        },
        responsive: {
            rules: [
                {
                    condition: {
                        maxWidth: responsive_util_1.getMobileBreakpointInPixel(),
                    },
                    chartOptions: {
                        legend: {
                            align: 'left',
                            symbolRadius: 0,
                            symbolHeight: 8,
                            itemStyle: {
                                fontWeight: 'normal',
                            },
                            useHTML: true,
                            labelFormatter: mobile_legend_item_formatter_1.default(theme),
                        },
                    },
                },
            ],
        },
    };
}
exports.default = createChartsConfig;
//# sourceMappingURL=charts-config.js.map